import React from 'react';
import View from './View';

import { SidebarPortal } from '@plone/volto/components';
import AZListSidebar from './Sidebar';

const Edit = (props) => {
  const { data, block, onChangeBlock, selected } = props;
  return (
    <div className="block azlist">
      <View {...props} isEditMode={true} />
      <SidebarPortal selected={selected}>
        <AZListSidebar
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </div>
  );
};

export default Edit;
